module.exports = __webpack_public_path__ + "static/media/2.8171f731.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/2.png
// module id = 1060
// module chunks = 0